export default {
  zh: {
    find:"Find",
    inviteHistory:"Invite History",
    inviteID:"Inviter ID",
    invitees:"Invitees",
    timeInvited:"Time Invited",
    id:"ID",
    enterID:"Enter the account ID",
    notExist:"The user does not exist",
    successful:"The operation was successful",
    banText:"Are you sure you want to reset?",
    haveHost:"The user joined another guild",
    invite:"Invite",
    removeText:"Are you sure to remove it?",
    yes: "confirm",
    no: "cancel",
    poaloder:'Enter reason',
    reason:"Reason",
    resetRoomData:"Reset room data",
    removeList:"Remove from homepage recommendation list",
  },
  en: {
    find:"Find",
    inviteHistory:"Invite History",
    inviteID:"Inviter ID",
    invitees:"Invitees",
    timeInvited:"Time Invited",
    id:"ID",
    enterID:"Enter the account ID",
    notExist:"The user does not exist",
    successful:"The operation was successful",
    banText:"Are you sure you want to reset?",
    haveHost:"The user joined another guild",
    invite:"Invite",
    removeText:"Are you sure about the ban?",
    yes: "confirm",
    no: "cancel",
    poaloder:'Enter reason',
    reason:"Reason",
    resetRoomData:"Reset room data",
    removeList:"Remove from homepage recommendation list",
    reset:"Reset",
    resetPersonalData:'Reset personal data',
    banorSet:"Ban Set",
    banInOne:"Ban",
    nohad:'No ban permission',
    noselectTypeText:"Please select the Type of ban",
    noselectTimeText:"Please select the Time of ban",
  },
  ar: { // 阿拉伯
    find:"وجد",
    inviteHistory:"دعوة السجل",
    inviteID:"ايدي المدعو",
    invitees:"المدعوون ",
    timeInvited:"وقت الدعوة ",
    id:"معرف",
    enterID:"ادخل ايدي الحساب",
    notExist:"المستخدم غير موجود",
    successful:"العملية كانت ناجحه",
    haveHost:"انضم المستخدم إلى نقابة أخرى",
    invite:" يدعو",
    banText:"هل أنت متأكد من الحظر ؟ ",
    removeText:"هل أنت متأكد من الحظر ؟ ",
    yes: "أكد",
    no: "إلغاء",
    poaloder:'أدخل السبب',
    reason:"السبب",
    resetRoomData:"إعادة ضبط بيانات الغرفة",
    removeList:"إزالة من قائمة توصيات الصفحة الرئيسية",
    reset:"إعادة ضبط",
    resetPersonalData:'إعادة ضبط البيانات الشخصية',
    banorSet:"مجموعة الحظر",
    banInOne:"الحظر",
    nohad:'لا يوجد إذن الحظر',
    noselectTypeText:"يرجى تحديد نوع الحظر",
    noselectTimeText:"يرجى تحديد وقت الحظر",
  },
  tr:{ //土耳其
    find:"Bul",
    inviteHistory:"Davet Geçmişi",
    inviteID:"Davet Eden Kimliği",
    invitees:"Davetliler",
    timeInvited:"Davet Edilen Zaman",
    id:"KİMLİĞİ",
    enterID:"Hesap ID Girin",
    notExist:"Kullanıcı mevcut değil",
    successful:"İşlem Başarılı Oldu",
    haveHost:"Kullanıcı başka bir loncaya katıldı",
    invite:"Davet Et",
    banText:"Banlamak istediğinizden emin misiniz?",
    removeText:"Banlamak istediğinizden emin misiniz?",
    yes: "onaylamak",
    no: "iptal etmek",
    poaloder:'Nedenini Girin',
    reason:"Sebep",
    resetRoomData:"Oda verilerini sıfırla",
    removeList:"Ana sayfa öneri listesinden kaldır",
    reset:"Sıfırla",
    resetPersonalData:'Kişisel verileri sıfırla',
    banorSet:"Ban Seç",
    banInOne:"yasağı",
    nohad:'Ban izni yok',
    noselectTypeText:"Lütfen Yasak Türünü Seçin",
    noselectTimeText:"Lütfen Yasak Zamanını Seçin",
  },
  pt:{
    "find": "Encontrar",
    "inviteHistory": "Histórico de Convites",
    "inviteID": "ID do Convidador",
    "invitees": "Convidados",
    "timeInvited": "Hora do Convite",
    "id": "ID",
    "enterID": "Digite o ID da conta",
    "notExist": "O usuário não existe",
    "successful": "A operação foi bem-sucedida",
    "banText": "Tem certeza de que deseja redefinir?",
    "haveHost": "O usuário entrou em outra guilda",
    "invite": "Convidar",
    "removeText": "Tem certeza de que deseja banir?",
    "yes": "confirmar",
    "no": "cancelar",
    "poaloder": "Digite o motivo",
    "reason": "Motivo",
    "resetRoomData": "Redefinir dados da sala",
    "removeList": "Remover da lista de recomendações na página inicial",
    "reset": "Redefinir",
    "resetPersonalData": "Redefinir dados pessoais",
    "banorSet": "Configuração de banimento",
    "banInOne": "Banir",
    "nohad": "Sem permissão para banir",
    "noselectTypeText": "Selecione o tipo de banimento",
    "noselectTimeText": "Selecione o tempo de banimento"
    },
  id:{
    "find": "Cari",
    "inviteHistory": "Riwayat Undangan",
    "inviteID": "ID Pengundang",
    "invitees": "Undangan",
    "timeInvited": "Waktu Diundang",
    "id": "ID",
    "enterID": "Masukkan ID akun",
    "notExist": "Pengguna tidak ada",
    "successful": "Operasi berhasil",
    "banText": "Apakah Anda yakin ingin mereset?",
    "haveHost": "Pengguna bergabung dengan guild lain",
    "invite": "Undang",
    "removeText": "Apakah Anda yakin tentang larangan ini?",
    "yes": "konfirmasi",
    "no": "batal",
    "poaloder": "Masukkan alasan",
    "reason": "Alasan",
    "resetRoomData": "Reset data ruangan",
    "removeList": "Hapus dari daftar rekomendasi beranda",
    "reset": "Reset",
    "resetPersonalData": "Reset data pribadi",
    "banorSet": "Setel Larangan",
    "banInOne": "Larangan",
    "nohad": "Tidak ada izin untuk melarang",
    "noselectTypeText": "Silakan pilih jenis larangan",
    "noselectTimeText": "Silakan pilih waktu larangan"
  },
  uz:{
    "find": "Topish",
    "inviteHistory": "Taklif Tarixi",
    "inviteID": "Taklif qiluvchi ID",
    "invitees": "Taklif qilinganlar",
    "timeInvited": "Taklif qilingan vaqt",
    "id": "ID",
    "enterID": "Akaunt ID sini kiriting",
    "notExist": "Foydalanuvchi mavjud emas",
    "successful": "Amal muvaffaqiyatli bajarildi",
    "banText": "Qayta tiklashni xohlaysizmi?",
    "haveHost": "Foydalanuvchi boshqa guildga qo'shildi",
    "invite": "Taklif qilish",
    "removeText": "Ta'qiqni tasdiqlaysizmi?",
    "yes": "tasdiqlash",
    "no": "bekor qilish",
    "poaloder": "Sababni kiriting",
    "reason": "Sabab",
    "resetRoomData": "Xona ma'lumotlarini tiklash",
    "removeList": "Bosh sahifa tavsiya ro'yxatidan o'chirish",
    "reset": "Tiklash",
    "resetPersonalData": "Shaxsiy ma'lumotlarni tiklash",
    "banorSet": "Ta'qiq o'rnatish",
    "banInOne": "Ta'qiq",
    "nohad": "Ta'qiqlash huquqi yo'q",
    "noselectTypeText": "Iltimos, ta'qiq turini tanlang",
    "noselectTimeText": "Iltimos, ta'qiq vaqtini tanlang"
    },
  ru:{
    "find": "Найти",
    "inviteHistory": "История приглашений",
    "inviteID": "ID Пригласившего",
    "invitees": "Приглашенные",
    "timeInvited": "Время приглашения",
    "id": "ID",
    "enterID": "Введите ID аккаунта",
    "notExist": "Пользователь не существует",
    "successful": "Операция была успешной",
    "banText": "Вы уверены, что хотите сбросить?",
    "haveHost": "Пользователь присоединился к другой гильдии",
    "invite": "Пригласить",
    "removeText": "Вы уверены, что хотите забанить?",
    "yes": "подтвердить",
    "no": "отмена",
    "poaloder": "Введите причину",
    "reason": "Причина",
    "resetRoomData": "Сбросить данные комнаты",
    "removeList": "Удалить из списка рекомендаций на главной странице",
    "reset": "Сбросить",
    "resetPersonalData": "Сбросить личные данные",
    "banorSet": "Настройки блокировки",
    "banInOne": "Заблокировать",
    "nohad": "Нет прав на блокировку",
    "noselectTypeText": "Пожалуйста, выберите тип блокировки",
    "noselectTimeText": "Пожалуйста, выберите время блокировки"
    },
  fa:{
    "find": "یافتن",
    "inviteHistory": "تاریخ دعوت",
    "inviteID": "شناسه دعوت‌کننده",
    "invitees": "دعوت‌شدگان",
    "timeInvited": "زمان دعوت",
    "id": "شناسه",
    "enterID": "شناسه حساب را وارد کنید",
    "notExist": "کاربر وجود ندارد",
    "successful": "عملیات با موفقیت انجام شد",
    "banText": "آیا مطمئن هستید که می‌خواهید تنظیمات را بازنشانی کنید؟",
    "haveHost": "کاربر به یک گیلد دیگر پیوسته است",
    "invite": "دعوت",
    "removeText": "آیا مطمئن هستید که می‌خواهید بن کنید؟",
    "yes": "تأیید",
    "no": "لغو",
    "poaloder": "دلیل را وارد کنید",
    "reason": "دلیل",
    "resetRoomData": "داده‌های اتاق را بازنشانی کنید",
    "removeList": "از فهرست پیشنهادات صفحه اصلی حذف کنید",
    "reset": "بازنشانی",
    "resetPersonalData": "داده‌های شخصی را بازنشانی کنید",
    "banorSet": "تنظیمات بن",
    "banInOne": "بن",
    "nohad": "هیچ مجوزی برای بن کردن وجود ندارد",
    "noselectTypeText": "لطفاً نوع بن را انتخاب کنید",
    "noselectTimeText": "لطفاً زمان بن را انتخاب کنید"
    }




}


// WEBPACK FOOTER //
// src/pages/admin-control/bane-reset/lang.js